import io from 'socket.io-client';
import config from '../config/config';

class SocketService {
  constructor() {
    this.socket = null;
    this.connected = false;
  }

  connect(token) {
    if (this.socket && this.connected) {
      return;
    }

    this.socket = io(config.SOCKET_URL, {
      auth: {
        token: token,
      },
      transports: ['websocket', 'polling'],
    });

    this.socket.on('connect', () => {
      console.log('Socket connected:', this.socket.id);
      this.connected = true;
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
      this.connected = false;
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
      this.connected = false;
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }
  }

  // Live Dashboard Updates
  onDashboardUpdate(callback) {
    if (this.socket) {
      this.socket.on('admin:dashboard-update', callback);
    }
  }

  // New Ride Notifications
  onNewRide(callback) {
    if (this.socket) {
      this.socket.on('admin:new-ride', callback);
    }
  }

  // Ride Status Updates
  onRideUpdate(callback) {
    if (this.socket) {
      this.socket.on('admin:ride-update', callback);
    }
  }

  // Driver Status Updates
  onDriverStatusUpdate(callback) {
    if (this.socket) {
      this.socket.on('admin:driver-status', callback);
    }
  }

  // Live Location Updates for Tracking
  onLocationUpdate(callback) {
    if (this.socket) {
      this.socket.on('admin:location-update', callback);
    }
  }

  // Emergency Alerts
  onEmergencyAlert(callback) {
    if (this.socket) {
      this.socket.on('admin:emergency-alert', callback);
    }
  }

  // New Driver Registration
  onNewDriverRegistration(callback) {
    if (this.socket) {
      this.socket.on('admin:new-driver', callback);
    }
  }

  // New Withdrawal Request
  onNewWithdrawal(callback) {
    if (this.socket) {
      this.socket.on('admin:new-withdrawal', callback);
    }
  }

  // Emit: Join live tracking room
  joinLiveTracking() {
    if (this.socket) {
      this.socket.emit('admin:join-live-tracking');
    }
  }

  // Emit: Leave live tracking room
  leaveLiveTracking() {
    if (this.socket) {
      this.socket.emit('admin:leave-live-tracking');
    }
  }

  // Remove specific listener
  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  // Remove all listeners
  removeAllListeners() {
    if (this.socket) {
      this.socket.removeAllListeners();
    }
  }
}

export default new SocketService();
